import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { AuditLogs } from '@/features/audit-logs'
import { requireActiveSubscription } from '@/lib/middleware'

const auditLogsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(25),
  search: z.string().optional().catch(''),
  entityType: z.string().optional().catch(''),
  action: z.string().optional().catch(''),
  startDate: z.string().optional().catch(''),
  endDate: z.string().optional().catch(''),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/audit-logs/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: AuditLogs,
  validateSearch: auditLogsSearchSchema,
})
